<template>
  <div class="car-model-layout mb-30">
    <section class="car-list-box">
      <div class="car-head">
        <img :src="carData.headerImg" alt="">
      </div>
      <article class="car-list-body">
        <div class="advantage-img">
          <img v-if="carData.advantageImg" class="mb-20" :src="carData.advantageImg" alt="">
          <img v-if="carData.contentImg" :src="carData.contentImg" alt="">
        </div>
        <ul class="img-group-list-box">
          <li
            class="mr-32"
            v-for="item in carData.carList"
            :key="item.id"
            @click="changeVehicle(item)"
          >
            <div class="img-group-box">
              <img class="driver-img" :src="item.carImg" alt="">
              <p class="tit-1">{{item.carName}}</p>
              <p class="tit-2">{{item.carIntroduce}}</p>
              <div class="hll-submit-btn">
                <img class="default-img" :src="carData.btnBackImg" alt="">
                <span class="small-tit">{{submitTimeValue ? '已预约' : carData.btnText}}</span>
              </div>
              <!-- <div class="small-btn-bg hll-oerder-btn">立即领取优惠</div> -->
            </div>
          </li>
        </ul>
        <template v-if="portType">
          <div class="more-car" @click="goOtherActivity"></div>
          <div class="car-buy-footer-box">
            <i>*</i>更有多达40款热销车型，具体可预约到店咨询
            <i>*</i>
          </div>
        </template>
      </article>
    </section>
  </div>
</template>

<script>
export default {
  props: ["carData", "typeName", "submitTimeValue", "portType"],
  methods: {
    changeVehicle(payload) {
      this.$emit("changeVehicle", { typeName: this.typeName, datas: payload, btnText: this.carData.btnText });
    },
    goOtherActivity () {
      this.$emit('goOtherActivity', {
        typeName: 'miniprogram',
        recordName: '查看更多车型',
        openPopupType: 'home',
        page: 'page/tabBar/homepage/index'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/rpx.scss";
@import "./../common.scss";
.car-model-layout {
  .hll-submit-btn {
    width: rpx(233);
  }
}
</style>
